import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  initialValue?: string;
  placeholder?: string;
  className?: string;
  autoSync?: boolean;
  onSubmitted?: (keyword: string) => void;
}

export default function SearchBar({
  initialValue = '',
  placeholder = '搜索电影标题、导演或演员',
  className = '',
  autoSync = false,
  onSubmitted,
}: SearchBarProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  useEffect(() => {
    if (autoSync) setValue(initialValue);
  }, [initialValue, autoSync]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const keyword = value.trim();
    if (onSubmitted) {
      onSubmitted(keyword);
      return;
    }
    navigate(keyword ? `/search?q=${encodeURIComponent(keyword)}` : '/search');
  };

  return (
    <form onSubmit={handleSubmit} role="search" className={`relative ${className}`}>
      <i
        className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-500"
        aria-hidden="true"
      />
      <input
        type="search"
        name="q"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        aria-label="搜索电影"
        className="w-full rounded-full border border-background-300/70 bg-background-200/70 py-2 pl-9 pr-20 text-sm text-foreground-100 placeholder:text-foreground-600 outline-none transition-colors focus:border-primary-400 focus:bg-background-200"
      />
      <button
        type="submit"
        className="absolute right-1 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-xs font-semibold text-foreground-950 transition-colors hover:bg-primary-400 cursor-pointer"
      >
        搜索
      </button>
    </form>
  );
}